import { useState, useEffect, useContext, useRef } from 'react';

import PracticeReserveSituationCase from './case/PracticeReserveSituationCase';

import { PracticeReserveSituationType } from '../../../../../../models/practice/reserve/situation/type/PracticeReserveSituationType';


// 内容選択
function PracticeReserveSituationModal() {

  // カテゴリ一覧表示(他は閉じる)
  const [openCateKey, setOpenCateKey] = useState<string>('');
  const cateRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  // 開いているカテゴリーが変わったら一番上になるようスクロール
  useEffect(() => {
    const target = cateRefs.current[openCateKey];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [openCateKey]);


  // 初心者におすすめ 
  const biginnerType: PracticeReserveSituationType = {
    groupId: 1,
    title: '初心者にオススメ！',
    icon: '/images/common/beginner.png',
    iconAlt: '初心者にオススメ！',
  }
  // ベーシック６回パック！
  const basicType: PracticeReserveSituationType = {
    groupId: 5,
    title: 'ベーシック６回パック！',
    icon: '/images/page/lesson/live/plane.png',
    iconAlt: 'ベーシック６回パック！',
  }
  // 教材理解を深めたい方に！
  const understandType: PracticeReserveSituationType = {
    groupId: 3,
    title: (
      <>
        教材理解を深めたい方に！
        <br className="visible-xs" />
        （教材をお持ちの方向け）
      </>
    ),
    icon: '/images/common/kyozai.png',
    iconAlt: '教材理解を深めたい方に！',
  }
  // スキルアップにオススメ！
  const skillUpType: PracticeReserveSituationType = {
    groupId: 2,
    title: 'スキルアップにオススメ！',
    icon: '/images/common/skillup.png',
    iconAlt: 'スキルアップにオススメ！',
  }
  // 会話力UPならこちら！
  const speakingType: PracticeReserveSituationType = {
    groupId: 4,
    title: '会話力UPならこちら！',
    icon: '/images/common/kaiwa.png',
    iconAlt: '会話力UPならこちら！',
  }


  return (
    <div style={{backgroundColor: '#fff'}}>

      <div className="alert alert-warning small" style={{ padding: '10px', margin: 0 }}>
        ◆ 各レッスン名の上にある「ミッション」にはレッスン前にどのようなことを練習したら良いか、レッスンで実践する内容が記載されています。
        <br />
        レッスン前に声に出してアウトプットをしながら練習をしましょう。
        <br />
        <br />
        ◆ 好評につき、「<span style={{color: '#31708f', fontWeight: 'bold'}}>キッズプラクティス（お子様／お孫様と受講できる）</span>」もいつでもご利用できるようになりました！
        <br />
      </div>

      {/* 初心者におすすめ */}
      <PracticeReserveSituationCase
        type={biginnerType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* ベーシック６回パック！ */}
      <PracticeReserveSituationCase
        type={basicType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* 教材理解を深めたい方に！ */}
      <PracticeReserveSituationCase
        type={understandType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* スキルアップにオススメ！ */}
      <PracticeReserveSituationCase
        type={skillUpType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* 会話力UPならこちら！ */}
      <PracticeReserveSituationCase
        type={speakingType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

    </div>
  );
}
  
export default PracticeReserveSituationModal;